import { persistTal } from 'api/targeting'
import store from 'config/store'
import { receiveCampaignEvalId } from 'modules/campaigns/actions'
import { chain, pathOr } from 'ramda'
import { EvaluatedTargetConditionSetItem, EvaluationResultToAuditLogArgs, TargetingAuditLog, TargetingAuditLogConditionSet, TargetingEvaluationResult, TargetingEvaluationStatus } from 'types/targeting'
import { warn } from 'utils'

import { getTargetingEvaluationMetadata } from '../utils'

export const AddEvaluationResultToAuditLog = ({
  auditLog,
  isServerGenerated = true,
  evaluationResults,
  didMatch,
  campaignId,
  priority,
  status = TargetingEvaluationStatus.EVALUATED
}: EvaluationResultToAuditLogArgs) => {
  if (!auditLog.conditionGroups) {
    return
  }

  const evaluationLog = isServerGenerated ?
    _generateAuditLogForServerEvaluationResults(evaluationResults) :
    evaluationResults

  auditLog.conditionGroups.push({
    status,
    matched: didMatch,
    conditionSets: evaluationLog,
    key: campaignId,
    priority
  })
}

export const _generateAuditLogForServerEvaluationResults = (serverEvaluationResults: TargetingEvaluationResult[]) => {
  const targetConditionSets = chain(result => result.evaluatedTargetConditionSet, serverEvaluationResults)
  return targetConditionSets.map(conditionSet => _generateAuditLogResultForConditionSet(conditionSet))
}

export const _generateAuditLogResultForConditionSet = (conditionSet: EvaluatedTargetConditionSetItem): TargetingAuditLogConditionSet => {
  const evaluatedCondition = pathOr(null, ['evaluatedTargetCondition', 'condition'], conditionSet)
  const matched = pathOr(false, ['evaluatedTargetCondition', 'matched'], conditionSet)
  const actualValue = pathOr(null, ['evaluatedTargetCondition', 'actualValue'], conditionSet)

  return {
    status: TargetingEvaluationStatus.EVALUATED,
    targetingConditions: [{
      evaluatedCondition,
      matched,
      actualValue,
      status: TargetingEvaluationStatus.EVALUATED,
      meta: {}
    }]
  }
}

export const SaveAuditLog = async (TAL: TargetingAuditLog) => {
  if (!TAL || !TAL.conditionGroups.length) {
    return
  }

  try {
    const { data } = await persistTal({
      ...TAL,
      ...getTargetingEvaluationMetadata()
    })

    store.dispatch(receiveCampaignEvalId({
      campaignEvalId: data.targetingEvaluationUUID
    }))
  } catch(err) {
    warn(['Failed to persist targeting audit log', err])
  }
}
